import { ChangeDetectionStrategy, Component, ViewEncapsulation, input } from '@angular/core';

/**
 * Page header: an optional area label, the page heading with an optional
 * count, a one-line subtitle, and actions on the right (wrapping under the
 * title on narrow screens). Pages without `heading` can still project a
 * `.header-title` element.
 */
@Component({
  selector: 'app-content-header-cabinet',
  templateUrl: './content-header.component.html',
  styleUrl: './content-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.ShadowDom,
  host: {
    '[class.level-2]': 'level() === 2',
  },
})
export class ContentHeaderCabinetComponent {
  /** Page title, Title Case. Rendered as an h1 (or h2 with `level` 2). */
  readonly heading = input<string>('');
  /** Number of items, shown after the title as "(52)". */
  readonly count = input<number | null>(null);
  readonly subtitle = input<string>('');
  /** Area name shown small above the title, e.g. "Administration". */
  readonly eyebrow = input<string>('');
  /** 1 for the page title, 2 for a further section on the same page. */
  readonly level = input<1 | 2>(1);
}
